export default __webpack_public_path__ + "static/media/logo.0fb09e0f.png";